export default __webpack_public_path__ + "static/media/Baby39.42aa2989.gif";